// extracted by mini-css-extract-plugin
export default {"info":"Info_info__JodxG","value_container":"Info_value_container__fN4T7","value":"Info_value__SRKJd"};